import { useEffect, useState } from "react";
import api, { fmtINR } from "@/lib/api";
import { Banknote } from "lucide-react";

export default function Cash() {
  const [d, setD] = useState(null);
  useEffect(() => { (async () => setD((await api.get("/cash")).data))(); }, []);
  if (!d) return <div className="text-sm">Loading...</div>;

  return (
    <div>
      <div className="overline">Cash Ledger</div>
      <h1 className="text-3xl font-bold tracking-tight mb-4">Cash in Hand</h1>
      <div className="grid grid-cols-3 gap-4 mb-6">
        <div className="bg-white border border-border rounded-lg p-5 kpi-card"><div className="overline">Balance</div><div className="text-3xl font-mono font-bold text-[#064E3B]" data-testid="cash-balance">{fmtINR(d.balance)}</div></div>
        <div className="bg-white border border-border rounded-lg p-5 kpi-card"><div className="overline">Cash In</div><div className="text-3xl font-mono font-bold text-[#166534]">{fmtINR(d.total_in)}</div></div>
        <div className="bg-white border border-border rounded-lg p-5 kpi-card"><div className="overline">Cash Out</div><div className="text-3xl font-mono font-bold text-[#991B1B]">{fmtINR(d.total_out)}</div></div>
      </div>

      <div className="bg-white border border-border rounded-lg overflow-x-auto">
        <table className="acc-table w-full">
          <thead><tr><th>Date</th><th>Type</th><th>Number</th><th>Party</th><th className="num">In</th><th className="num">Out</th></tr></thead>
          <tbody>
            {d.entries.map((t) => (
              <tr key={t._id_str + t.flow}>
                <td>{new Date(t.date).toLocaleDateString()}</td>
                <td className="uppercase text-xs">{t.txn_type.replace("_", " ")}</td>
                <td className="font-mono">{t.number}</td>
                <td>{t.party_name || "—"}</td>
                <td className="num text-[#166534]">{t.flow === "in" ? fmtINR(t.paid || t.total) : ""}</td>
                <td className="num text-[#991B1B]">{t.flow === "out" ? fmtINR(t.paid || t.total) : ""}</td>
              </tr>
            ))}
            {d.entries.length === 0 && <tr><td colSpan={6} className="text-center py-6 text-muted-foreground">No cash transactions.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
